import { Route } from '@/core/entities/types/routes';
import { BillingModel } from '@/modules/billing/entities/billing.enums';
import { Company } from '@/modules/company/entities/interfaces/company';
import { User } from '@/modules/profile';
import { isEmpty } from 'lodash';

interface ValidatePermissionInput {
  item: Route,
  user: User,
  company: Company,
  companyBillingModel?: BillingModel
}

export const validatePermission = (
  {
    item,
    user,
    companyBillingModel
  }: ValidatePermissionInput
) => {
  let isValidCurrRoutePermissions = false;
  const hasPermission = !!item?.meta?.permission;
  const currRouteType = item?.meta?.permission?.type;
  const currRoutePermissions = item?.meta?.permission?.values || [];
  const isValidCurrRouteType = !currRouteType?.length || currRouteType === user.type;
  const currRouteBillingModels = item?.meta?.permission?.billingModels || [];

  if (!hasPermission) {
    return true;
  }

  if (!currRoutePermissions.length) {
    isValidCurrRoutePermissions = true;
  } else if (!isEmpty(user)) {
    isValidCurrRoutePermissions = currRoutePermissions.some((routePermission) =>
      user.permissions.includes(routePermission),
    );
  }

  if (currRouteBillingModels.length) {
    isValidCurrRoutePermissions = currRouteBillingModels.some((configBillingModel) => configBillingModel === companyBillingModel);
  }

  return isValidCurrRouteType && isValidCurrRoutePermissions;
};
